import React from "react";

const Body = ({ children }) => (
  <React.Fragment key="children">{children}</React.Fragment>
);

export default Body;
